import { render, staticRenderFns } from "./upcoming-deliveries.vue?vue&type=template&id=4db8c302&scoped=true"
import script from "./upcoming-deliveries.vue?vue&type=script&lang=js"
export * from "./upcoming-deliveries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db8c302",
  null
  
)

export default component.exports